/* eslint-disable sonarjs/no-duplicate-string */

export const features = [
  'Seja leal a você e também com a equipe.',
  'Tenha obsessão pelo cliente, focando em ganhar e manter a confiança e superar expectativas.',
  'Tenha iniciativa, saia da zona de conforto.',
  'Faça mais com menos, sempre buscando inovar.',
  'Insista nos mais altos padrões, aumente a barra e foque na qualidade.',
];
